import create from "zustand";

const useStore = create((set) => ({
  update: (payload) => set((state) => ({ ...state, ...payload })),
}));

export default useStore;
